export default "__VITE_ASSET__mpeWFLph__"